import form from './form.reducer';
import formBundleForms from './formBundleForms.reducer';
import formBundles from './formBundles.reducer';
import formBundleSchema from './formBundles.schema.reducer';
import formBundlesAfterSubmitSchema from './formBundlesAfterSubmit.schema.reducer';
import forms from './forms.reducer';
import roleBasedSigningSchema from './roleBasedSigningSchema.reducer';

const reducer = {
  forms,
  form,
  formBundles,
  formBundleForms,
  formBundleSchema,
  formBundlesAfterSubmitSchema,
  roleBasedSigningSchema,
};

export default reducer;
